/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function () {
  var PREORDER_INVENTORY_THRESHOLD = 1;
  var scheduledUpdate = null;

  function getLanguage(key, fallback) {
    return window.languages && window.languages[key] ? window.languages[key] : fallback;
  }

  function getPreOrderLabel() {
    return 'PREORDER';
  }

  function getAddToCartLabel() {
    return getLanguage('productFormAddToCart', 'Add to cart');
  }

  function parseJson(value) {
    if (!value) {
      return null;
    }

    try {
      return JSON.parse(value);
    } catch (error) {
      return null;
    }
  }

  function toNumber(value) {
    var number = typeof value === 'number' ? value : parseInt(value, 10);
    return isNaN(number) ? null : number;
  }

  function getVariantValue(variant, inventory, key) {
    if (inventory && inventory[key] !== undefined && inventory[key] !== null) {
      return inventory[key];
    }

    return variant ? variant[key] : null;
  }

  function shouldShowPreOrder(variant, inventory) {
    if (!variant || variant.available === false) {
      return false;
    }

    var inventoryManagement = getVariantValue(variant, inventory, 'inventory_management');
    var inventoryPolicy = getVariantValue(variant, inventory, 'inventory_policy');
    var inventoryQuantity = toNumber(getVariantValue(variant, inventory, 'inventory_quantity'));

    if (inventoryManagement !== undefined && inventoryManagement !== null && inventoryManagement === '') {
      return false;
    }

    return inventoryPolicy === 'continue' && inventoryQuantity !== null && inventoryQuantity < PREORDER_INVENTORY_THRESHOLD;
  }

  function setLabelText(labelElement, label) {
    if (!labelElement) {
      return;
    }

    var currentText = labelElement.textContent.trim();

    if (!labelElement.dataset.preorderOriginalLabel && currentText !== getPreOrderLabel()) {
      labelElement.dataset.preorderOriginalLabel = currentText;
    }

    if (currentText !== label) {
      labelElement.textContent = label;
    }
  }

  function restoreLabelText(labelElement) {
    if (!labelElement || labelElement.dataset.preorderActive !== 'true') {
      return;
    }

    var originalLabel = labelElement.dataset.preorderOriginalLabel || getAddToCartLabel();
    labelElement.textContent = originalLabel;
    labelElement.dataset.preorderActive = 'false';
  }

  function getProductJson(scope) {
    var productJsonElement = scope && scope.querySelector ? scope.querySelector('[data-product-json]') : null;

    if (!productJsonElement) {
      productJsonElement = document.querySelector('[data-product-json]');
    }

    return productJsonElement ? parseJson(productJsonElement.textContent) : null;
  }

  function findVariantById(variants, variantId) {
    if (!variants || !variantId) {
      return null;
    }

    variantId = String(variantId);

    for (var index = 0; index < variants.length; index += 1) {
      if (String(variants[index].id) === variantId) {
        return variants[index];
      }
    }

    return null;
  }

  function getSelectedVariantId(scope, data) {
    var variantInput = scope && scope.querySelector ? scope.querySelector('input[name="id"], select[name="id"]') : null;

    if (variantInput && variantInput.value) {
      return variantInput.value;
    }

    return data && data.selected_variant_id ? data.selected_variant_id : null;
  }

  function getNativeVariant(scope, explicitVariant) {
    var data = getProductJson(scope);

    if (!data) {
      return {
        variant: explicitVariant || null,
        inventory: null
      };
    }

    var variant = explicitVariant || findVariantById(data.product && data.product.variants, getSelectedVariantId(scope, data));
    var inventory = variant && data.inventories ? data.inventories[variant.id] : null;

    return {
      variant: variant,
      inventory: inventory
    };
  }

  function updateNativeProduct(scope, explicitVariant) {
    var variantData = getNativeVariant(scope, explicitVariant);
    var preorderActive = shouldShowPreOrder(variantData.variant, variantData.inventory);
    var addToCartButtons = scope && scope.querySelectorAll ? scope.querySelectorAll('.ProductForm__AddToCart') : [];

    Array.prototype.forEach.call(addToCartButtons, function (button) {
      var labelElement = button.querySelector('span');

      if (preorderActive) {
        setLabelText(labelElement, getPreOrderLabel());
        if (labelElement) {
          labelElement.dataset.preorderActive = 'true';
        }
      } else {
        restoreLabelText(labelElement);
      }
    });

    Array.prototype.forEach.call(scope && scope.querySelectorAll ? scope.querySelectorAll('.shopify-payment-button') : [], function (paymentButton) {
      if (preorderActive) {
        paymentButton.style.display = 'none';
      } else if (variantData.variant && variantData.variant.available !== false) {
        paymentButton.style.display = '';
      }
    });
  }

  function getGemPagesData(scope) {
    var variantsElement = scope && scope.querySelector ? scope.querySelector('gp-product-variants[gp-data]') : null;

    if (!variantsElement && scope && scope.closest) {
      var productElement = scope.closest('gp-product');
      variantsElement = productElement ? productElement.querySelector('gp-product-variants[gp-data]') : null;
    }

    return variantsElement ? parseJson(variantsElement.getAttribute('gp-data')) : null;
  }

  function getGemPagesVariant(scope, data) {
    if (!data || !data.variants) {
      return {
        variant: null,
        inventory: null
      };
    }

    var selectedVariantId = getSelectedVariantId(scope, data) || data.variantSelected && data.variantSelected.id;
    var variant = findVariantById(data.variants, selectedVariantId) || data.variantSelected || data.firstAvailableVariant || null;
    var variantIndex = -1;

    if (variant) {
      for (var index = 0; index < data.variants.length; index += 1) {
        if (String(data.variants[index].id) === String(variant.id)) {
          variantIndex = index;
          break;
        }
      }
    }

    var inventory = null;

    if (variantIndex >= 0) {
      inventory = {
        inventory_management: variant.inventory_management,
        inventory_policy: data.variantInventoryPolicy ? data.variantInventoryPolicy[variantIndex] : variant.inventory_policy,
        inventory_quantity: data.variantInventoryQuantity ? data.variantInventoryQuantity[variantIndex] : variant.inventory_quantity
      };
    }

    return {
      variant: variant,
      inventory: inventory
    };
  }

  function updateGemPagesProduct(scope) {
    var data = getGemPagesData(scope);
    var variantData = getGemPagesVariant(scope, data);
    var preorderActive = shouldShowPreOrder(variantData.variant, variantData.inventory);
    var productButtons = scope && scope.querySelectorAll ? scope.querySelectorAll('gp-product-button') : [];

    Array.prototype.forEach.call(productButtons, function (productButton) {
      var addButton = productButton.querySelector('button[name="add"], .gp-button-atc');
      var labelElement = addButton ? addButton.querySelector('.gp-content-product-button, .button-text, [data-gp-text]') : null;

      if (preorderActive) {
        setLabelText(labelElement, getPreOrderLabel());
        if (labelElement) {
          labelElement.dataset.preorderActive = 'true';
        }

        if (addButton) {
          addButton.setAttribute('aria-label', getPreOrderLabel());
        }
      } else {
        restoreLabelText(labelElement);

        if (addButton) {
          addButton.setAttribute('aria-label', labelElement && labelElement.textContent.trim() ? labelElement.textContent.trim() : getAddToCartLabel());
        }
      }
    });
  }

  function updateAllPreOrderButtons(root, explicitVariant) {
    var scope = root && root.querySelectorAll ? root : document;
    var nativeScopes = scope.querySelectorAll('[data-section-type="product"], [data-section-type="featured-product"]');
    var gemPagesScopes = scope.querySelectorAll('gp-product');

    if (scope.matches && (scope.matches('[data-section-type="product"], [data-section-type="featured-product"]'))) {
      updateNativeProduct(scope, explicitVariant);
    }

    Array.prototype.forEach.call(nativeScopes, function (nativeScope) {
      updateNativeProduct(nativeScope, explicitVariant);
    });

    if (scope.matches && scope.matches('gp-product')) {
      updateGemPagesProduct(scope);
    }

    Array.prototype.forEach.call(gemPagesScopes, function (gemPagesScope) {
      updateGemPagesProduct(gemPagesScope);
    });
  }

  function schedulePreOrderButtonUpdate(root, explicitVariant) {
    window.clearTimeout(scheduledUpdate);

    scheduledUpdate = window.setTimeout(function () {
      updateAllPreOrderButtons(root || document, explicitVariant);
    }, 75);
  }

  document.addEventListener('variant:changed', function (event) {
    schedulePreOrderButtonUpdate(event.target, event.detail && event.detail.variant);
  });

  document.addEventListener('change', function (event) {
    if (event.target && event.target.matches('input[name="id"], select[name="id"], .ProductForm__Option input, gp-product-variants input, gp-product-variants select')) {
      schedulePreOrderButtonUpdate(event.target.closest('gp-product') || event.target.closest('[data-section-type="product"], [data-section-type="featured-product"]') || document);
    }
  });

  document.addEventListener('click', function (event) {
    if (event.target && event.target.closest('gp-product-variants, .ProductForm__Option, .Popover__Value, .VariantSelector__Choice')) {
      schedulePreOrderButtonUpdate(event.target.closest('gp-product') || event.target.closest('[data-section-type="product"], [data-section-type="featured-product"]') || document);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      schedulePreOrderButtonUpdate(document);
    });
  } else {
    schedulePreOrderButtonUpdate(document);
  }
}());

(function () {
  if (!document.body || !document.body.classList.contains('template-product')) {
    return;
  }

  var styleId = 'bj-growave-reviews-one-column-runtime';
  var css = [
    '.template-product [id*="growave_loyalty_wishlist_block_product_review_widget"],',
    '.template-product [class*="growave_loyalty_wishlist_block_product_review_widget"],',
    '.template-product .gw-rv-main-widget-placeholder,',
    '.template-product .gw-container.ssw-review-widget-lazyload {',
    '  width: 100% !important;',
    '  max-width: 100% !important;',
    '}',
    '.template-product .gw-rv-main-widget-placeholder [class*="grid"],',
    '.template-product .gw-rv-main-widget-placeholder [class*="Grid"],',
    '.template-product .gw-rv-main-widget-placeholder [class*="list"],',
    '.template-product .gw-rv-main-widget-placeholder [class*="List"],',
    '.template-product .gw-rv-main-widget-placeholder [class*="items"],',
    '.template-product .gw-rv-main-widget-placeholder [class*="Items"],',
    '.template-product .gw-rv-main-widget-placeholder form,',
    '.template-product .gw-rv-main-widget-placeholder form [class*="row"],',
    '.template-product .gw-rv-main-widget-placeholder form [class*="Row"],',
    '.template-product .gw-container.ssw-review-widget-lazyload [class*="grid"],',
    '.template-product .gw-container.ssw-review-widget-lazyload [class*="Grid"],',
    '.template-product .gw-container.ssw-review-widget-lazyload [class*="list"],',
    '.template-product .gw-container.ssw-review-widget-lazyload [class*="List"],',
    '.template-product .gw-container.ssw-review-widget-lazyload form,',
    '.template-product .gw-container.ssw-review-widget-lazyload form [class*="row"],',
    '.template-product .gw-container.ssw-review-widget-lazyload form [class*="Row"] {',
    '  grid-template-columns: minmax(0, 1fr) !important;',
    '  columns: 1 !important;',
    '  column-count: 1 !important;',
    '}',
    '.template-product .gw-rv-main-widget-placeholder [class*="review"],',
    '.template-product .gw-rv-main-widget-placeholder [class*="Review"],',
    '.template-product .gw-container.ssw-review-widget-lazyload [class*="review"],',
    '.template-product .gw-container.ssw-review-widget-lazyload [class*="Review"] {',
    '  width: 100% !important;',
    '  max-width: 100% !important;',
    '  flex: 0 0 100% !important;',
    '  flex-basis: 100% !important;',
    '}'
  ].join('\n');

  function installStyle() {
    if (document.getElementById(styleId)) {
      return;
    }

    var style = document.createElement('style');
    style.id = styleId;
    style.textContent = css;
    document.head.appendChild(style);
  }

  function enforceOneColumn(root) {
    installStyle();
    Array.prototype.forEach.call((root || document).querySelectorAll('.gw-rv-main-widget-placeholder, .gw-container.ssw-review-widget-lazyload'), function (widget) {
      widget.style.setProperty('width', '100%', 'important');
      widget.style.setProperty('max-width', '100%', 'important');
      Array.prototype.forEach.call(widget.querySelectorAll('[class*="grid"], [class*="Grid"], [class*="list"], [class*="List"], [class*="items"], [class*="Items"], form, form [class*="row"], form [class*="Row"]'), function (node) {
        node.style.setProperty('grid-template-columns', 'minmax(0, 1fr)', 'important');
        node.style.setProperty('columns', '1', 'important');
        node.style.setProperty('column-count', '1', 'important');
      });
      Array.prototype.forEach.call(widget.querySelectorAll('[class*="review"], [class*="Review"]'), function (node) {
        node.style.setProperty('width', '100%', 'important');
        node.style.setProperty('max-width', '100%', 'important');
        node.style.setProperty('flex-basis', '100%', 'important');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      enforceOneColumn(document);
    });
  } else {
    enforceOneColumn(document);
  }

  window.addEventListener('load', function () {
    enforceOneColumn(document);
  });

  var attempts = 0;
  var timer = window.setInterval(function () {
    enforceOneColumn(document);
    attempts += 1;
    if (attempts > 12) {
      window.clearInterval(timer);
    }
  }, 750);

  new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i += 1) {
      for (var j = 0; j < records[i].addedNodes.length; j += 1) {
        if (records[i].addedNodes[j] && records[i].addedNodes[j].nodeType === 1) {
          enforceOneColumn(records[i].addedNodes[j]);
        }
      }
    }
  }).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
}());

/* Bonheur duplicate product state button guard - 2026-09-09 */
(function () {
  if (!/^\/products\//.test(window.location.pathname) && !document.querySelector('gp-product, form[data-type="add-to-cart-form"], [data-section-type="product"]')) {
    return;
  }

  var scheduled = null;
  var selector = [
    'gp-product-button',
    'gp-product-button .gp-button-base',
    'gp-product-button button',
    '.ProductForm__AddToCart',
    'button[name="add"]',
    '.gp-button-sold-out',
    '[data-id*="sold-out"]'
  ].join(', ');

  function cleanText(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
  }

  function isVisible(element) {
    if (!element) {
      return false;
    }

    var styles = window.getComputedStyle(element);
    return styles.display !== 'none' && styles.visibility !== 'hidden' && styles.opacity !== '0';
  }

  function getButtonState(button) {
    var text = cleanText(button.innerText || button.textContent || button.value || '');
    var aria = cleanText(button.getAttribute('aria-label') || '');
    var signature = [
      button.className || '',
      button.getAttribute('data-id') || '',
      button.getAttribute('dataid') || ''
    ].join(' ');

    if (/^pre[-\s]?order$/i.test(text) || /^pre[-\s]?order$/i.test(aria)) {
      return 'preorder';
    }

    if (/^(out of stock|sold out)$/i.test(text) || /^(out of stock|sold out)$/i.test(aria) || /sold-out|button-sold-out/i.test(signature)) {
      return 'soldout';
    }

    return '';
  }

  function getWrapper(button) {
    return button.closest('gp-product-button') || button;
  }

  function resetHidden(scope) {
    Array.prototype.forEach.call(scope.querySelectorAll('[data-bj-product-state-duplicate="true"]'), function (element) {
      element.style.removeProperty('display');
      element.removeAttribute('data-bj-product-state-duplicate');
    });
  }

  function hideDuplicate(button) {
    var wrapper = getWrapper(button);
    wrapper.style.setProperty('display', 'none', 'important');
    wrapper.setAttribute('data-bj-product-state-duplicate', 'true');
  }

  function dedupeInScope(scope) {
    var seen = {};
    var processedWrappers = [];

    resetHidden(scope);

    Array.prototype.forEach.call(scope.querySelectorAll(selector), function (button) {
      var wrapper = getWrapper(button);

      if (processedWrappers.indexOf(wrapper) !== -1 || !isVisible(button) || !isVisible(wrapper)) {
        return;
      }

      processedWrappers.push(wrapper);

      var state = getButtonState(button);
      if (!state) {
        return;
      }

      if (seen[state]) {
        hideDuplicate(button);
      } else {
        seen[state] = true;
      }
    });
  }

  function dedupeAll() {
    var scopes = document.querySelectorAll('gp-product');

    if (scopes.length) {
      Array.prototype.forEach.call(scopes, dedupeInScope);
    } else {
      dedupeInScope(document);
    }
  }

  function scheduleDedupe() {
    window.clearTimeout(scheduled);
    scheduled = window.setTimeout(dedupeAll, 175);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleDedupe);
  } else {
    scheduleDedupe();
  }

  window.addEventListener('load', scheduleDedupe);
  document.addEventListener('variant:changed', scheduleDedupe);

  document.addEventListener('change', function (event) {
    if (event.target && event.target.matches('input[name="id"], select[name="id"], gp-product-variants input, gp-product-variants select')) {
      scheduleDedupe();
    }
  });

  var attempts = 0;
  var interval = window.setInterval(function () {
    dedupeAll();
    attempts += 1;

    if (attempts > 12) {
      window.clearInterval(interval);
    }
  }, 500);

  new MutationObserver(scheduleDedupe).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
}());
/* End Bonheur duplicate product state button guard */



/* Keep the Kieran stock-counter behavior consistent across GemPages products. */
(function () {
  var UPDATE_DELAY = 100;
  var updateTimer = null;

  var LIGHTNING_ICON = '<svg aria-hidden="true" viewBox="0 0 256 256" fill="currentColor"><path d="M213.85,125.46l-112,120a8,8,0,0,1-13.69-7l14.66-73.33L45.19,143.49a8,8,0,0,1-3-13l112-120a8,8,0,0,1,13.69,7L153.18,90.9l57.63,21.61a8,8,0,0,1,3,12.95Z"></path></svg>';
  var PACKAGE_ICON = '<svg aria-hidden="true" viewBox="0 0 256 256" fill="currentColor"><path d="M223.68,66.15,135.68,18a15.88,15.88,0,0,0-15.36,0l-88,48.17a16,16,0,0,0-8.32,14v95.64a16,16,0,0,0,8.32,14l88,48.17a15.88,15.88,0,0,0,15.36,0l88-48.17a16,16,0,0,0,8.32-14V80.18A16,16,0,0,0,223.68,66.15ZM128,32l80.34,44-29.77,16.3-80.35-44ZM128,120,47.66,76l33.9-18.56,80.34,44ZM40,90l80,43.78v85.79L40,175.82Zm176,85.78h0l-80,43.79V133.82l32-17.51V152a8,8,0,0,0,16,0V107.55L216,90v85.77Z"></path></svg>';

  function parseVariantData(product) {
    var dataElement = product.querySelector('gp-product-variants script[gp-data]');

    if (!dataElement) {
      return null;
    }

    try {
      return JSON.parse(dataElement.textContent);
    } catch (error) {
      return null;
    }
  }

  function getSelectedVariant(product, data) {
    var optionGroups = product.querySelectorAll('gp-product-variants [variant-option-name]');
    var selectedValues = [];

    Array.prototype.forEach.call(optionGroups, function (group) {
      var selected = group.querySelector('input:checked, select');

      if (selected && selected.value) {
        selectedValues.push(selected.value);
      }
    });

    if (selectedValues.length && data.variants) {
      for (var index = 0; index < data.variants.length; index += 1) {
        var variant = data.variants[index];
        var options = variant.options || [];

        if (options.length === selectedValues.length && options.every(function (value, optionIndex) {
          return String(value) === String(selectedValues[optionIndex]);
        })) {
          return variant;
        }
      }
    }

    return data.variantSelected || data.firstAvailableVariant || null;
  }

  function getVariantInventory(data, variant) {
    var index = -1;

    if (!variant || !data.variants) {
      return null;
    }

    for (var variantIndex = 0; variantIndex < data.variants.length; variantIndex += 1) {
      if (String(data.variants[variantIndex].id) === String(variant.id)) {
        index = variantIndex;
        break;
      }
    }

    if (index < 0) {
      return null;
    }

    return {
      management: variant.inventory_management,
      policy: data.variantInventoryPolicy ? data.variantInventoryPolicy[index] : variant.inventory_policy,
      quantity: data.variantInventoryQuantity ? data.variantInventoryQuantity[index] : variant.inventory_quantity
    };
  }

  function ensureCounterStyles() {
    if (document.getElementById('bonheur-gp-stock-counter-styles')) {
      return;
    }

    var style = document.createElement('style');
    style.id = 'bonheur-gp-stock-counter-styles';
    style.textContent = '@media (max-width:767px){.bonheur-gp-stock-counter__message{font-size:14px!important;}}';
    document.head.appendChild(style);
  }

  function createCounter() {
    ensureCounterStyles();

    var wrapper = document.createElement('div');
    wrapper.className = 'bonheur-gp-stock-counter';
    wrapper.setAttribute('gp-el-wrapper', '');
    wrapper.style.cssText = '--mb:var(--g-s-2xl);display:block;margin-bottom:var(--g-s-2xl,32px);width:100%;';
    wrapper.innerHTML = '<div class="bonheur-gp-stock-counter__row" style="display:flex;align-items:baseline;justify-content:flex-start;column-gap:4px;">' +
      '<span class="bonheur-gp-stock-counter__icon" aria-hidden="true" style="display:block;flex:0 0 16px;width:16px;height:16px;color:#121212;">' + LIGHTNING_ICON + '</span>' +
      '<p class="bonheur-gp-stock-counter__message" style="margin:0;font-family:\'Nexa Text W05 Regular\',var(--g-font-body,body);font-size:16px;font-weight:400;line-height:180%;color:#4D4D4D;"></p>' +
      '</div>';
    return wrapper;
  }

  function setCounterState(counter, message, outOfStock) {
    var icon = counter.querySelector('.bonheur-gp-stock-counter__icon');
    var messageElement = counter.querySelector('.bonheur-gp-stock-counter__message');
    var state = message ? (outOfStock ? 'out-of-stock' : 'in-stock') : 'hidden';

    if (!message) {
      if (counter.dataset.state !== state) {
        counter.style.display = 'none';
        counter.dataset.state = state;
      }
      return;
    }

    if (counter.dataset.state !== state) {
      counter.style.display = 'block';
      icon.innerHTML = outOfStock ? PACKAGE_ICON : LIGHTNING_ICON;
      icon.style.color = outOfStock ? '#DDDDDD' : '#121212';
      messageElement.style.color = outOfStock ? '#DDDDDD' : '#4D4D4D';
      counter.dataset.state = state;
    }

    if (messageElement.textContent !== message) {
      messageElement.textContent = message;
    }
  }

  function updateProduct(product) {
    var injectedCounter = product.querySelector('.bonheur-gp-stock-counter');

    if (product.querySelector('gp-product-stock-counter')) {
      if (injectedCounter) {
        injectedCounter.remove();
      }
      return;
    }

    var productButtons = product.querySelectorAll('gp-product-button');

    if (!productButtons.length) {
      return;
    }

    var data = parseVariantData(product);
    var variant = data ? getSelectedVariant(product, data) : null;
    var inventory = data && variant ? getVariantInventory(data, variant) : null;

    if (!data || !variant || !inventory) {
      return;
    }

    var counter = injectedCounter || createCounter();

    if (!injectedCounter) {
      productButtons[productButtons.length - 1].insertAdjacentElement('afterend', counter);
    }

    if (!inventory.management || inventory.quantity === null || inventory.quantity === undefined) {
      setCounterState(counter, '', false);
    } else if (variant.available === false && inventory.policy !== 'continue') {
      setCounterState(counter, 'Out of stock!', true);
    } else if (Number(inventory.quantity) <= 0 && inventory.policy === 'continue') {
      setCounterState(counter, 'OUT OF STOCK', true);
    } else {
      setCounterState(counter, 'Only ' + Math.max(0, Number(inventory.quantity)) + ' left', false);
    }
  }

  function updateAllProducts() {
    Array.prototype.forEach.call(document.querySelectorAll('gp-product'), function (product) {
      if (product.querySelector('gp-product-button')) {
        updateProduct(product);
      }
    });
  }

  function scheduleUpdate() {
    window.clearTimeout(updateTimer);
    updateTimer = window.setTimeout(updateAllProducts, UPDATE_DELAY);
  }

  document.addEventListener('change', function (event) {
    if (event.target && event.target.closest('gp-product-variants')) {
      scheduleUpdate();
    }
  });

  document.addEventListener('click', function (event) {
    if (event.target && event.target.closest('gp-product-variants')) {
      scheduleUpdate();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleUpdate);
  } else {
    scheduleUpdate();
  }

  new MutationObserver(scheduleUpdate).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
}());
